const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/kurser/mjukvaruutvecklingsprojekt'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Mjukvaruutvecklingsprojekt (1DV613)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/1dv613' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'Moodle', link: 'https://moodle.lnu.se/my/courses.php'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema1/ri1Y7X7QQYwZ36Qv570X3785y5Y95Z7Y8275999Q2.html'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    courseCode: '1DV613',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
